import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { DisplayToast } from 'gossamer-front-end';

export const PageFrame = (): React.JSX.Element => {
  // const [mobileSidebarOpen, setMobileSidebarOpen] = React.useState(false);
  // const className = 'pageframe mobileSidebar' + (mobileSidebarOpen ? 'Open' : 'Closed');
  // const toggleMobileSidebar = () => setMobileSidebarOpen(!mobileSidebarOpen);
  const className = 'pageframe';
  return (
    <div className={className}>
      <Outlet />
      <DisplayToast />
    </div>
  );
};
